import requestCommon from "@/components/web-interface/requestCommon";
import axios from "axios";
const state = {
  orderDetails: null,
  referenceData: null,
  reportDetails: null,
};
const actions = {
  getOrderDetails(context, data) {
    let fill = "";
    if (data.filter) {
      fill = "filter=" + data.filter
    }
    let portfolioNames = "";
    if (data.portfolioNames) {
      portfolioNames = "&portfolioNames=" + data.portfolioNames
    }
    return requestCommon.getInfo(
      "/orders?" + fill + "&filterField=" + data.filterField + "&from=" + data.fromDate + "&to=" + data.toDate + portfolioNames + "&direction=" + data.direction + "&pageNo=" + data.pageNo + "&pageSize=" + data.pageSize + "&sortBy=" + data.sortBy,
      data,
      null,
      context,
      "getOrderDetailsSuccessHandler",
      "getOrderDetailsErrorHandler"
    );
  },
  getOrderById(context, data) {
    return requestCommon.getInfo(
      "/orders" + "/" + data.id,
      data,
      null,
      context,
      "getOrderByIdSuccessHandler",
      "getOrderByIdErrorHandler"
    );
  },
  getOrderReport(context, data) {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + sessionStorage.getItem('accessToken'),
    };
    return axios.get(process.env.VUE_APP_FIREFLY_API_URL + "/orders/report/" + data.type + "?from=" + data.from + "&to=" + data.to, { headers: headers, responseType: "blob" });
  },
  getOrderRetryDetails(context, data) {
    return requestCommon.getInfo(
      "/orders/retry",
      data,
      null,
      context,
      "getOrderRetryDetailsSuccessHandler",
      "getOrderRetryDetailsErrorHandler"
    );
  },
  orderRetry(context, data) {
    return requestCommon.postInfo(
      "/orders/retry",
      data,
      data,
      context,
      "orderRetrySuccessHandler",
      "orderRetryErrorHandler"
    );
  },
}
const mutations = {
  getOrderDetailsSuccessHandler(state, data) {
    state.orderDetails = data.server.data;
  },
  getOrderDetailsErrorHandler(context, error) {
    console.log(error);
  },
  getOrderByIdSuccessHandler(state, data) {
    state.orderDetails = data.server.data;
  },
  getOrderByIdErrorHandler(context, error) {
    console.log(error);
  },
  getOrderReportSuccessHandler(state, data) {
    state.reportDetails = data.server.data;
  },
  getOrderReportErrorHandler(context, error) {
    console.log(error);
  },
  getOrderRetryDetailsSuccessHandler(state, data) {
    console.log(data);
  },
  getOrderRetryDetailsErrorHandler(context, error) {
    console.log(error);
  },
  orderRetrySuccessHandler(state, data) {
    console.log(data);
  },
  orderRetryErrorHandler(context, error) {
    console.log(error);
  },
};
const getters = {};
export const orderStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
